import { selectAtomPerMinute } from "./helpers/select-atom-per-minute";
import { nowSecondAtom } from "./now-seconds.atom";

/**
 * This represents the current minute which is updated only every minute.
 */
export const nowAtom = selectAtomPerMinute(nowSecondAtom);
